import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "computerWithBoxAndPencils",
    iconColor: "white",
    text: `Innovation at \nour core with \n<b>50+ patents</b>`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "peopleAndCheckmark",
    iconColor: "white",
    text: `Trusted by\n<b>400+ customers</b>`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "peopleWithMessageCloud",
    iconColor: "white",
    text: `Run by <b>1,400+ \ntechnology \nenthusiasts</b>`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "chipWithCheckmark",
    iconColor: "white",
    text: `<b>95% </b> Client \nRetention Rate`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_EV_1 = {
  styleLeftPanel: {
    paddingRight: 0,
    paddingTop: "54px",
    paddingBottom: "51px",
    borderRadius: "0px 300px 15px 0px",
    minWidth: "1195px",
    minHeight: "845px",
  },
  titleStyle: { marginBottom: "20px" },
  styleListData: { marginTop: "-30px", marginBottom: "60px" },
  panelLogo: "EV/EV_intro_logo.png",
  title: "Global Digital \nPlatform Solutions",
  text: "EdgeVerve, an Infosys subsidiary, leads in developing digital platforms, \nunlocking transformation possibilities and inspiring enterprises worldwide.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(402),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "EV/EV_demo_Intro_01.png",
  headerRightText: "GET THE EDGE",
  headerLeftImage: "EdgeverveLogo.png",
  rightSideImage: "EV/EV_intro_QR.png",
};
